<script setup lang="ts">
import router from '@/router'
router.push('/member/map')
</script>
<template>
</template>
